import * as actionTypes from "~/store/action_types";

const cancellationPasswordVerified = (state = false, action) => {
  switch (action.type) {
    case actionTypes.VERIFY_PASSWORD_LOADING:
      return state;

    case actionTypes.VERIFY_PASSWORD_SUCCESS:
      return true;

    case actionTypes.VERIFY_PASSWORD_ERROR:
      return state;

    default:
      return state;
  }
};

export default cancellationPasswordVerified;
